import LanguageSwitcher from 'components/LanguageSwitcher/LanguageSwitcher';
import {
  IconWrapper,
  IconsWrapper,
  Container,
  Content,
  Label,
  Logo,
  LogoWrapper,
} from './AuthWrapper.styled';
import logo from 'assets/icons/logo.svg';
import logoDark from 'assets/icons/logo-dark.svg';
import ToggleDarkMode from 'components/ToggleDarkMode/ToggleDarkMode';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';

interface IAuthWrapperProps {
  title: string;
  children: React.ReactNode;
}

const AuthWrapper = ({ title, children }: IAuthWrapperProps) => {
  const { darkMode } = useSelector(
    (state: IRootReducerState) => state.commonInfo
  );

  return (
    <Container>
      <Content>
        <LogoWrapper>
          <Logo src={darkMode ? logoDark : logo} alt="" />
          <IconsWrapper>
            <IconWrapper>
              <ToggleDarkMode />
            </IconWrapper>
            <IconWrapper>
              <LanguageSwitcher />
            </IconWrapper>
          </IconsWrapper>
        </LogoWrapper>
        <Label>{title}</Label>

        <>{children}</>
      </Content>
    </Container>
  );
};

export default AuthWrapper;
